import { useCallback, useMemo } from 'react';
import { useCurrentViewPropertySession } from 'src/hooks/use-current-view-property-session';

export const getAcademicYearType = (academicYears, id) =>
  Object.entries(academicYears).find(([, item]) => item?.id === id)?.[0];

export const useGetAcademicYearTitle = () => {
  return useCallback((name) => name, []);
};

export const haveAcademicYearsOnThisProperty = (property) =>
  property.academicYear.past.length > 0 || property.academicYear.current.length > 0;

/**
 * @typedef {Object} AcademicYear
 * @property {string} name
 *
 * @param {Object} academicYears
 * @param {AcademicYear} academicYears.past
 * @param {AcademicYear} academicYears.current
 */

/**
 *
 * @param {Object} academicYear
 *
 * @param {Array} academicYear.past
 * @param {string} academicYear.past.name
 * @param {string} academicYear.past.id
 *
 * @param {Array} academicYear.current
 * @param {string} academicYear.current.name
 * @param {string} academicYear.past.id
 */
export function useAcademicYearList(academicYear) {
  const activeAcademicYears = academicYear?.current;

  const list = useMemo(
    () =>
      activeAcademicYears.map((item) => ({
        label: item.name,
        value: item.id,
        disabled: !item.id,
      })),
    [activeAcademicYears]
  );
  return list;
}

export const useAcademicYearListOnFormikSelect = () => {
  const [{ currentViewProperty }] = useCurrentViewPropertySession();

  return useMemo(
    () =>
      currentViewProperty.academicYear?.current.map((item) => ({
        value: item.id,
        children: item.name,
        label: item.name,
        enabled: item.isEnabled.toString(),
        fromYear: item?.fromYear,
        toYear: item?.toYear,
        flexibilityControlInfo: {
          setUpRateType: item?.flexibilityControlInfo?.setUpRateType,
        },
      })),
    [currentViewProperty]
  );
};

export const useLandlordAcademicYearListOnFormikSelect = () => {
  const [{ currentViewLandLord }] = useCurrentViewPropertySession();

  return useMemo(
    () =>
      currentViewLandLord?.groupAcademicYears?.map((item) => ({
        value: item.id,
        children: item.name,
        label: item.name,
        fromYear: item?.fromYear,
        toYear: item?.toYear,
      })),
    [currentViewLandLord?.groupAcademicYears]
  );
};
